import type { LocaleDict } from '../../lib/i18n/types';
import type { SubagentState } from '../../lib/transcript';

/** One order for the telemetry rail: running children first, newest start first.
 * Old transcript entries can omit timestamps; updated time orders those with no start,
 * and undated entries retain their relative order after dated entries in the same group. */
export function orderAgents(agents: readonly SubagentState[]): SubagentState[] {
  const started = (agent: SubagentState): number => {
    const timestamp = agent.startedAt ?? agent.updatedAt;
    return timestamp === undefined ? 0 : Date.parse(timestamp);
  };
  return [...agents].sort((a, b) =>
    Number(b.status === 'running') - Number(a.status === 'running') || started(b) - started(a));
}

/** The status of a steer into an already-running child, shared by the tool log. */
export function steerDescription(agent: SubagentState, labels: LocaleDict['agents']): string {
  if (agent.steerState === 'dropped') return agent.steerReason
    ? `${labels.steerDropped}: ${agent.steerReason}` : labels.steerDropped;
  if (agent.steerState === 'queued') return labels.steerQueued;
  return agent.steerState === 'delivered' ? labels.steerDelivered : labels.steeredInto;
}
